import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {Swiper as SwiperBase} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import {images} from '../../../assets/icons';
import {useTheme} from '../../theme';
import {Theme} from '../../theme/interface';
import {Props} from './model';
import {useDimensions} from '../../hooks/useDimensions';

SwiperCore.use([Navigation]);

const useStyles = makeStyles({
  container: {
    position: 'relative',
    '& .swiper-container': {
      width: '100%',
    },
    '& .swiper-slide': {
      display: 'flex',
    },
    display: 'flex',
  },
  containerWide: {
    width: 'calc(100% + 136px)',
    marginLeft: -68,
    marginRight: -68,
  },
  arrow: {
    '&:hover': {
      color: (theme: Theme) => theme.color.grayMenu,
      backgroundColor: (theme: Theme) => theme.color.primaryColor,
    },
    '&:not(:hover)': {
      color: (theme: Theme) => theme.color.primaryColor,
    },
    borderColor: (theme: Theme) => theme.color.primaryColor,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '50%',
    lineHeight: 0,
    cursor: 'pointer',
    userSelect: 'none',
    alignSelf: 'center',
    minWidth: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  swiper: {
    marginLeft: 17,
    marginRight: 17,
    paddingTop: 18,
    paddingBottom: 35,
  },
  swiperWide: {
    marginLeft: 10,
    marginRight: 10,
  },
});

export const ViewDesktop: React.FC<Props> = ({children, breakpoints, slidesPerView}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [arrowLeftEl, setArrowLeftEl] = React.useState<HTMLDivElement | null>(null);
  const [arrowRightEl, setArrowRightEl] = React.useState<HTMLDivElement | null>(null);
  const childrenArr = Array.isArray(children) && children;
  const {width: windowWidth} = useDimensions();

  /* In order to prevent incorrect spacing between slides, array of elements should be filled first */
  if (!childrenArr) {
    return null;
  }

  const isWideMonitor = windowWidth > 1500;

  const leftTestId = {'data-testid': 'swiper-desktop-left-id'};
  const rightTestId = {'data-testid': 'swiper-desktop-right-id'};

  return (
    <div className={[classes.container, ...(isWideMonitor ? [classes.containerWide] : []), 'swiper'].join(' ')}>
      <div {...leftTestId} ref={setArrowLeftEl} className={classes.arrow}>
        <images.Left />
      </div>
      {arrowLeftEl && arrowRightEl && (
        <SwiperBase
          className={[classes.swiper, ...(isWideMonitor ? [classes.swiperWide] : [])].join(' ')}
          navigation={{
            prevEl: arrowLeftEl,
            nextEl: arrowRightEl,
          }}
          slidesPerView={slidesPerView}
          breakpoints={breakpoints}
          loop>
          {children}
        </SwiperBase>
      )}
      <div {...rightTestId} ref={setArrowRightEl} className={classes.arrow}>
        <images.Right />
      </div>
    </div>
  );
};
